import React from 'react'
import Mainlayout from '../layouts/Mainlayout'

function Contact() {

    const contact={
        padding: '20px',
        backgroundColor: '#f8f9fa',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)'
    }

  return (
    <Mainlayout>
        <div style={contact}>
        <h1>Contact Us</h1>
        <p>This is the Contact Us page.</p>
        <p>@copyright <span>Abid Hasan</span></p>
        </div>
    </Mainlayout>
  )
}

export default Contact